import { render, staticRenderFns } from "./oilsInvoice.vue?vue&type=template&id=00724676&scoped=true&"
import script from "./oilsInvoice.vue?vue&type=script&lang=js&"
export * from "./oilsInvoice.vue?vue&type=script&lang=js&"
import style0 from "./oilsInvoice.vue?vue&type=style&index=0&id=00724676&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00724676",
  null
  
)

export default component.exports